import { createFileRoute } from '@tanstack/react-router';
import { JobPostImportRequestsNewTemplate } from '@/features/agent/provided_job_posts/new/csv/templates/JobPostImportRequestsNewTemplate';

export const Route = createFileRoute('/agent/provided_job_posts/new/csv/')({
  component: JobPostImportRequestsNew,
  staticData: { title: 'CSVから取り込み' },
});

function JobPostImportRequestsNew() {
  return <JobPostImportRequestsNewTemplate />;
}
